/* eslint-disable @typescript-eslint/no-explicit-any */
import { put, select, takeLatest } from 'redux-saga/effects';
import { getQueuesStatus } from '../web-socket/requests';
import { appInitialStatusRequested } from '../reducers/app';
import { debug, initLogger } from '../utils/logger';
import { WS_REQUEST_SAGA } from '../features/queues';
import { getAppSettings } from '../utils/storage';
import { getCBXSocket } from '../web-socket/client';
import { fullQueuesPath } from '../navigation';

function* deviceConnectResponse(action: any) {
  // @ts-ignore
  const appSettings = yield getAppSettings();
  // @ts-ignore
  const state = yield select((s) => s);
  const { boothId } = appSettings;
  yield put({ type: WS_REQUEST_SAGA, ...getQueuesStatus(boothId) });
  yield put(appInitialStatusRequested());
  initLogger(getCBXSocket().ws);
  debug('Logger initialized', { appState: state });
  if (!window.location.pathname.includes('queues')) {
    window.location.assign(fullQueuesPath());
  }
}

export function* handleDeviceConnectResponseSaga() {
  yield takeLatest(
    'web-socket/device/device-connect-response/cbx',
    deviceConnectResponse
  );
}
